"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions);
    },
})(function isSurfaceActionsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceActions, userOptions.readSurfaceActions), userOptions.readSurfaceActions) ||
        isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceAddins, userOptions.readSurfaceAddins), userOptions.readSurfaceAddins) ||
        isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceActions, userOptions.composeSurfaceActions), userOptions.composeSurfaceActions) ||
        isOptionDirty(owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceAddins, userOptions.composeSurfaceAddins), userOptions.composeSurfaceAddins));
});
function isOptionDirty(optionState, userOption) {
    // For easy array comparison:
    // First, slice each array to create a copy so we don't modify the real data.
    // Second, sort them since order isn't important for this feature.
    // Third, join them to create a single string of all the actions/addins.
    // Finally, compare the strings.
    return (optionState
        .slice()
        .sort()
        .join() !==
        userOption
            .slice()
            .sort()
            .join());
}
//# sourceMappingURL=isSurfaceActionsOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/utils/isSurfaceActionsOptionDirty.js
// module id = 3763
// module chunks = 2